import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { AllianceEntity } from ".";
import PubSub from "pubsub-js";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedAllianceEntity(alliance_id: number): Promise<AllianceEntity | null> {
  let entity: any = await cache.get(alliance_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const alliance = await esiClient.get_alliances_alliance_id(alliance_id, null, null);
    if (alliance !== null) {
      entity = new AllianceEntity(alliance_id, alliance);
      cache.put(alliance_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error: any) {
    console.error(error);
    if (error.error) PubSub.publish("ERROR", "ESI Error: " + error.error);
    return null;
  }
}
